import React, { useEffect, useState } from 'react'
import { Grid, Icon } from '@material-ui/core'
import ModalBase from '../../../../../components/Modals/ModalBase'
import DisplayText from '../../../../../components/Texts/DisplayText'
import { generalCatalogs } from '../../../../../variables/catalogs'
import { request_patient } from './requests'
import { nodata } from '../../../../../variables/config'
import moment from 'moment-timezone'

const PatientEventModal = props => {

    const {data, initData, open, onClose} = props

    const [patient, setPatient] = useState(null)
    const [benefit, setBenefit] = useState(null)

    useEffect(() => {
        const onRequestPatient = async() => {
            try {
              const response = await request_patient(initData.reference_1_id)
              setPatient(response)
            } catch (error) {
              console.log('Hubo un error')
            }
        }
        
        if(initData){
            onRequestPatient()
            if(initData.reference_2_id)
                setBenefit(generalCatalogs.benefit_levels[initData.reference_2_id])
        }
    },[initData, open])

    const date_info = initData && initData.created_at ? moment(`${initData.created_at}Z`).tz(moment.tz.guess()) : null
    const date = date_info ? date_info.format('YYYY-MM-DD') : nodata
    const hour = date_info ? date_info.format('HH:mm') : nodata

    return(
        <ModalBase open={open} onClose={onClose}>
            <div>
                <Grid container direction='column' spacing={2}>
                    <Grid item xs>
                        <DisplayText variant='h6'>{data.title}</DisplayText>
                    </Grid>
                    <Grid item xs>
                        <Grid container direction='column' alignItems='flex-end' spacing={2}>
                            <Grid item xs>   
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <DisplayText variant='body1'>{date}</DisplayText>
                                    </Grid>
                                    <Grid item>
                                        <Icon>calendar_today</Icon>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs>   
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <DisplayText variant='body1'>{hour}</DisplayText>
                                    </Grid>
                                    <Grid item>
                                        <Icon>schedule</Icon>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {Object.keys(data.content).map((item,key) => {
                        return(
                            <Grid item xs key={key}>
                                <Grid container direction='column'>
                                    <Grid item xs>   
                                        <DisplayText variant='subtitle1'>{data.content[item]}</DisplayText>
                                    </Grid>
                                    <Grid item xs>   
                                        <DisplayText variant='body1'>{initData ? initData[item]: null}</DisplayText>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )    
                    })}
                    {Object.keys(data.patient).map((item,key) => {
                        return(
                            <Grid item xs key={key}>
                                <Grid container direction='column'>
                                    <Grid item xs>   
                                        <DisplayText variant='subtitle1'>{data.patient[item]}</DisplayText>
                                    </Grid>
                                    <Grid item xs>   
                                        <DisplayText variant='body1'>{patient ? patient[item]: null}</DisplayText>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )    
                    })}
                    {benefit ? Object.keys(data.benefit).map((item,key) => {
                        return(
                            <Grid item xs key={key}>
                                <Grid container direction='column'>
                                    <Grid item xs>   
                                        <DisplayText variant='subtitle1'>{data.benefit[item]}</DisplayText>
                                    </Grid>
                                    <Grid item xs>   
                                        <DisplayText variant='body1'>{benefit ? benefit[item]: null}</DisplayText>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )    
                    }) : null}
                    
                </Grid>
            </div>
        </ModalBase>
    )
}

export default PatientEventModal